import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/auth/AppAuthContext";
import { Textbox } from "../components/Common/Textbox";
import { TextArea } from "../components/Common/TextArea";
import { SendSupportEmail } from "../firestore/Functions/SupportEmailFunctions";
import { useUtility } from "../contexts/auth/UtilityContext";
import AlumniLogoText from "../assets/svg/AlumniLogoText.svg"
import { Button } from "../components/Common/Button";
export function ContactUs() {
    const navigate = useNavigate();
    const { account } = useAuth();

    const [emailBody, setEmailBody] = useState("");

    const [contactName, setContactName] = useState(account?.FirstName);

    const [contactEmail, setContactEmail] = useState(account?.Email);

    const { setNewToast } = useUtility();


    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        switch (name) {
            case "contactname":
                setContactName(value);
                break;
            case "email":
                setContactEmail(value);
                break;
            default:
                break;
        }
    };
    
    const handleSendSupportEmail = async () => {
        if (contactEmail === "" || emailBody === "") {
            setNewToast({ title: "Error", message: "Please fill a email and a message", toastType: "error" });
            return;
        }
        await SendSupportEmail(contactName, contactEmail, emailBody)
            .then(() => {
                setNewToast({ title: "Success", message: "Thankyou for contacting support, we will get back to you as soon as we can.", toastType: "success" });
                setEmailBody("");
            })
            .catch((error) => {
                setNewToast({ title: "Error", message: error.message, toastType: "error" });
            });
        
    }

    return (
        <main className="absolute-0">
            <div className="flex mt-[2%] flex-row w-full mb-5 px-10">
                
                <div className="grow"><img src={AlumniLogoText} alt="" width="100px" height="100px" /></div>
                <div className="pt-7">
                    <button className="button1 mx-[3%]" onClick={() => navigate(-1)}>Back</button>
                </div>
            </div>
            <div className="section-box p-4 m-20 gap-4 grow max-w-[700px] m-auto">
                <div className="text-xl flex flex-row">
                    <div className="flex flex-row grow">
                        <h3 className="section-title">Contact Us/ Support</h3>
                    </div>
                </div>
                <Textbox label={"Contact Name"} name={"contactname"} value={contactName ?? ""} onValueChange={handleInputChange} isReadonly={account.FirstName !== undefined} ></Textbox>
                <Textbox label={"Email"} name={"email"} value={contactEmail ?? ""} onValueChange={handleInputChange} isReadonly={account.Email !== undefined} ></Textbox>
                <label className="basic-form-label">
                    <span>Message</span>
                </label>
                <TextArea label={""} name={"message"} onValueChange={(name, value) => {setEmailBody(value)}} value={emailBody}></TextArea>
                <p className="basic-form-label">Hold on tight, Well get back to you as soon as we can! </p>
                <div className="flex flex-row-reverse">
                    <Button onClick={handleSendSupportEmail} className="primary-button">
                        Send Request
                    </Button>
                </div>
              
            </div>
        </main>
    );
}